var _defs, _ellipse, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaused({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.942,
    height: 19.942,
    viewBox: "0 0 19.942 19.942",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffa514;}.b{fill:#fff;}"))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 9.971,
    cy: 9.971,
    rx: 9.971,
    ry: 9.971
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.884 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.1,0H.828A.854.854,0,0,0,0,.878a.854.854,0,0,0,.828.878H9.1A.854.854,0,0,0,9.932.878.854.854,0,0,0,9.1,0Z",
    transform: "translate(1.757) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.1,0H.828A.854.854,0,0,0,0,.878a.854.854,0,0,0,.828.878H9.1A.854.854,0,0,0,9.932.878.854.854,0,0,0,9.1,0Z",
    transform: "translate(6.303) rotate(90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaused);
export default __webpack_public_path__ + "static/media/paused.d4c7d3220f44a2a079d423227ca3f01d.svg";
export { ForwardRef as ReactComponent };